
import {defaultRenderer} from 'components/Assistant/ChatArea/renderer';

import {ANL} from './ANL';

const BaseResponse = defaultRenderer;

export default Object.assign(BaseResponse, {
	ANL,
});
